module.exports = __webpack_public_path__ + "img/profile-pic-gamer.b5d918cf.jpg";